// Dumb grid — no store, no SQL, no API, no router. Since IA_ABSORPTION_PLAN Phase 4 step 13.3b
// (2026-10-09) it renders @rdrive/plugin-data-table's DuckDbDataTable: paging, page size, sort,
// the debounced search, the filter-context / dataLoaded reloads and both layouts are the table's
// (its footer guarantee included); this component keeps what is rdrive-item specific — the
// headers, the item row with its expandable sub-item rows, the mobile card, the user avatars and
// the report button + dialog.
//
//   props:  filterContext  (Object, required)  duck type { filtersLastUpdated, ... }; a tick
//                                     reloads from page 1 (the table's `filterContext`)
//           itemsView      (String)   source view name, passed to generateReport only
//           dataLoaded     (Boolean)  false → true reloads from page 1; it gates nothing
//           apiHost        (String)   host with any leading 'api-' ALREADY stripped
//           projectCode    (String)
//           statusTemplates(Object)   keyed by status id  (mobile status chip)
//           itemTemplates  (Object)   keyed by profile id (mobile icon + deep link)
//           categories     (Object)   keyed by category id (mobile icon)
//           currentUserId  (String)   sorted to the front of the avatar list
//           users          (Object)   keyed by user id -> { displayName, avatarUrl }
//           fetchPage      (Function, required) ({ page, itemsPerPage, sort, search })
//                                     -> { items, totalItems }; the table's provider, as is
//                                     (the app's fetchPage loads its own user lookup)
//           openUrl        (Function) defaults to window.open(url, '_blank')
//           generateReport (Function|null) null hides the Reports button entirely
//           reportBusy     (Boolean)  the report dialog's spinner
//   emits:  none. Filtering happens through the filterContext the page owns.
import { DuckDbDataTable } from '@rdrive/plugin-data-table';
import ItemsGridPaginatedReportsDialog from '../ItemsGridPaginatedReportsDialog/component.vue';
import setup from './setup.js';

export default {
  name: 'items-grid',
  props: {
    filterContext: {
      type: Object,
      required: true
    },
    // Source view for item rows; the Activity page passes its
    // status-history-scoped view instead of the default filter_context one
    itemsView: {
      type: String,
      default: 'filteredItems'
    },
    dataLoaded: {
      type: Boolean,
      default: false
    },
    // Already stripped of a leading 'api-' by the page
    apiHost: {
      type: String,
      default: ''
    },
    projectCode: {
      type: String,
      default: ''
    },
    statusTemplates: {
      type: Object,
      default: () => ({})
    },
    itemTemplates: {
      type: Object,
      default: () => ({})
    },
    categories: {
      type: Object,
      default: () => ({})
    },
    currentUserId: {
      type: [String, Number],
      default: ''
    },
    users: {
      type: Object,
      default: () => ({})
    },
    fetchPage: {
      type: Function,
      required: true
    },
    openUrl: {
      type: Function,
      default: (url) => window.open(url, '_blank')
    },
    // null/undefined hides the download button and the dialog
    generateReport: {
      type: Function,
      default: null
    },
    reportBusy: {
      type: Boolean,
      default: false
    }
  },
  components: { DuckDbDataTable, ItemsGridPaginatedReportsDialog },
  setup,
};
